import { lazy } from 'react';
export var MainPageAsync = lazy(function () { return import('./MainPage'); });
